/**
 * Nút "…" mở menu thao tác — kiểu Figma SP-005 (nút trên thẻ `26:8094`, nút cạnh "Vô hiệu hoá" `26:8082`): nền trắng,
 * viền `#e8e8e8`, bo 8, 40×40, bóng nhẹ, chấm đen. SCSS ở `styles/common/_common.scss` (`.ellipsis-btn`).
 *
 * Dùng CHUNG cho nút "…" trên thẻ tài khoản liên kết và nút "…" của 4 drawer chi tiết tài khoản — trước 19/09/2026 hai nút
 * trên CÙNG một màn khác hẳn nhau (drawer dùng ảnh `show-more.svg` nền xám, thẻ dùng Button viền trắng). Ảnh đó còn dùng ở
 * nơi khác trong app nên KHÔNG sửa file ảnh.
 *
 * `forwardRef`: làm con trực tiếp của antd `Dropdown` được (trigger gắn `ref` + `onClick` vào con).
 */
import React, { forwardRef } from 'react'
import { Button } from 'antd'
import type { ButtonProps } from 'antd'
import { EllipsisOutlined } from '@ant-design/icons'

export const ELLIPSIS_BUTTON_CLASS = 'ellipsis-btn'

export type EllipsisButtonProps = Omit<ButtonProps, 'icon' | 'size' | 'children'>

const EllipsisButton = forwardRef<HTMLButtonElement | HTMLAnchorElement, EllipsisButtonProps>(
  ({ className, ...rest }, ref) => (
    <Button
      ref={ref}
      size="large"
      icon={<EllipsisOutlined />}
      className={className ? `${ELLIPSIS_BUTTON_CLASS} ${className}` : ELLIPSIS_BUTTON_CLASS}
      {...rest}
    />
  ),
)

EllipsisButton.displayName = 'EllipsisButton'

export default EllipsisButton
